import React from 'react';
import { Row, Col, Input, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../../constants/colors';

const EventTypeSearchBar = ({
  searchValue,
  onSearchChange,
  hasActiveFilters,
  onFilterClick,
  onCreateClick
}) => {
  return (
    <Row gutter={[8, 8]} align="middle" style={{ minHeight: '40px' }}>
      <Col flex="auto" className="search-input">
        <style>
          {`
            .search-input .ant-input-affix-wrapper {
              height: 40px !important;
              border-radius: 8px;
              border: 1px solid #e8e8e8;
              transition: all 0.3s ease;
              display: flex;
              align-items: center;
            }
            
            .search-input .ant-input-affix-wrapper:hover {
              border-color: #1890ff;
            }
            
            .search-input .ant-input-affix-wrapper:focus-within {
              border-color: #1890ff;
              box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15);
            }
            
            .search-input .ant-input-affix-wrapper .ant-input {
              border: none !important;
              box-shadow: none !important;
              height: auto !important;
              padding: 0;
            }
            
            .search-input .ant-input-affix-wrapper .ant-input-prefix {
              margin-right: 8px;
              color: #999;
            }
            
            @media (max-width: 768px) {
              .search-input {
                width: 100% !important;
                flex: 0 0 100% !important;
                max-width: 100% !important;
                margin-bottom: 8px;
              }
              
              .filter-controls {
                width: 100% !important;
                flex: 0 0 100% !important;
                max-width: 100% !important;
                display: flex !important;
                justify-content: space-between !important;
              }
              
              .filter-controls .ant-btn {
                flex: 1 !important;
              }
              
              .filter-controls .ant-btn:last-child {
                white-space: nowrap;
              }
            }
          `}
        </style>
        <Input
          placeholder="Search event types..."
          prefix={<FontAwesomeIcon icon={faSearch} />}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: '100%' }}
        />
      </Col>
      
      <Col flex="none" className="filter-controls">
        <Button
          type="default"
          icon={<FontAwesomeIcon icon={faFilter} />}
          onClick={onFilterClick}
          style={{
            marginRight: '8px',
            fontSize: '14px',
            color: hasActiveFilters ? COLORS.$primaryBlue : COLORS.textMedium,
            borderColor: hasActiveFilters ? COLORS.$primaryBlue : COLORS.border,
            background: hasActiveFilters ? `${COLORS.$primaryBlue}08` : 'white',
            position: 'relative',
          }}
        >
          Filter
          {hasActiveFilters && (
            <span style={{
              position: 'absolute',
              top: '-6px',
              right: '-6px',
              background: COLORS.$primaryBlue,
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '600',
              border: '2px solid white'
            }}>
              1
            </span>
          )}
        </Button>
        <Button
          type="primary"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={onCreateClick}
          style={{
            borderRadius: '6px',
            background: COLORS.$primaryBlue,
            borderColor: COLORS.$primaryBlue,
            fontWeight: 400,
          }}
        >
          Create Event Type
        </Button>
      </Col>
    </Row>
  );
};

export default EventTypeSearchBar;
